module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    class: {
      active: _vm.active
    },
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-controls": _vm.id,
      "role": "tab",
      "data-toogle": "tab"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onTabClick(_vm.id)
      }
    }
  }, [(!!_vm.icon) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v(_vm._s(_vm.icon))]) : _vm._e(), _vm._v(_vm._s(_vm.name)), _c('div', {
    staticClass: "ripple-container"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c2164a6","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/core/components/mdTab/nav-tab.vue
// module id = 1599
// module chunks = 0